import { AppRouteProps } from "@harea/component";
import React from "react";

const TaxBracketsCreate = React.lazy(() => import("./containers/TaxBracketCreate"));

export const TaxBracketsCreateRoutes: Array<AppRouteProps> = [
    {
        path: "create",
        title: "Harea.UserOrganisation.TaxBracket.Create.Title",
        element: <TaxBracketsCreate />,
    },
    {
        path: ":id/edit",
        title: "Harea.UserOrganisation.TaxBracket.Edit.Title",
        element: <TaxBracketsCreate />,
    },
];